module.exports = __webpack_public_path__ + "img/GrüneBrücke.7cdc66bd.jpg";